// extracted by mini-css-extract-plugin
module.exports = {"contain":"_-EqxBzE","header":"_2kJhANe","grid":"_23Z8tnE","col2":"_2FMIo8r","col3":"_1OnAR_3","col4":"_25h_zx7"};